(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coffee-filter-meta"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const root = document.querySelector('[data-coffee-filter]');
    if (!root) return;

    // These pills/squares drive Eurus's OWN collection grid (#ProductGridContainer)
    // through its native Alpine AJAX component (xFiltersAndSortby -> removeFilter()).
    // Each button carries its own facet param via data-filter-param (e.g.
    // "filter.p.tag" or "filter.v.option.Roast"), so tag groups and variant-option
    // groups can coexist. Liquid resolves that param and the value from
    // collection.filters, so both are already correct for the active language.
    // For tag groups, set the Tag filter to "match all" / AND in Search & Discovery;
    // variant-option groups are their own facet and AND naturally.
    function paramFor(btn) { return btn.dataset.filterParam || 'filter.p.tag'; }

    // Locate Eurus's filtering Alpine component (only exists if the native grid
    // section has filtering/sorting enabled).
    function nativeData() {
      const el = document.querySelector('[x-data*="xFiltersAndSortby"]');
      if (el && window.Alpine && Alpine.$data) {
        try { return Alpine.$data(el); } catch (e) { return null; }
      }
      return null;
    }

    // Values belonging to a group (lowercased) — used for radio-style replace.
    function groupValues(groupId) {
      return Array.from(root.querySelectorAll('[data-filter-group="' + groupId + '"]'))
        .map(b => (b.dataset.filterValue || '').toLowerCase());
    }

    // Toggle the pressed states of the buttons from a query string (per-button param).
    function setActive(searchParams) {
      const sp = new URLSearchParams(searchParams);
      root.querySelectorAll('[data-filter-value]').forEach(btn => {
        const active = sp.getAll(paramFor(btn)).map(t => t.toLowerCase());
        const val = (btn.dataset.filterValue || '').toLowerCase();
        btn.classList.toggle('is-active', active.includes(val));
      });
    }

    // Build the new query params for a click (group-aware radio replace + toggle-off).
    function buildParams(btn) {
      const param = paramFor(btn);
      const groupId = btn.dataset.filterGroup;
      const value = btn.dataset.filterValue || '';
      const lower = value.toLowerCase();
      const siblings = groupValues(groupId);

      const params = new URLSearchParams(window.location.search);
      const existing = params.getAll(param);
      const alreadyActive = existing.some(t => t.toLowerCase() === lower);

      // Within THIS group's facet: drop this group's values (radio replace), keep any
      // values from other groups that happen to share the same facet (e.g. other tag groups).
      params.delete(param);
      existing.forEach(t => {
        if (!siblings.includes(t.toLowerCase())) params.append(param, t);
      });
      // Re-add the clicked value unless it was already active (clicking again clears the group).
      if (!alreadyActive) params.append(param, value);

      params.delete('page'); // filters changed → back to page 1
      return params.toString();
    }

    // Hand the target URL to Eurus's native AJAX so it re-renders #ProductGridContainer.
    function applyFilter(searchParams) {
      setActive(searchParams);
      const data = nativeData();
      const target = searchParams
        ? window.location.pathname + '?' + searchParams
        : window.location.pathname;

      if (data && typeof data.removeFilter === 'function') {
        data.removeFilter(target); // updates grid, count, native filters, and the URL
      } else {
        // Native component not found → degrade to a real navigation.
        window.location.search = searchParams ? '?' + searchParams : '';
      }
    }

    root.querySelectorAll('[data-filter-value]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        applyFilter(buildParams(btn));
      });
    });

    // Eurus already re-renders the grid on back/forward; just keep the pills in sync.
    window.addEventListener('popstate', function() {
      setActive(window.location.search.slice(1));
    });

    setActive(window.location.search.slice(1));

    // Center the active category within the mobile carousel on load.
    var cats = root.querySelector('.cf-categories');
    var activeCat = root.querySelector('.cf-cat.is-active');
    if (cats && activeCat && cats.scrollWidth > cats.clientWidth) {
      cats.scrollLeft = activeCat.offsetLeft - (cats.clientWidth - activeCat.clientWidth) / 2;
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
